module.exports = __webpack_public_path__ + "media/images/fb_mobile-70b591f179b80bdab6782aa23f822888.svg";